import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAiModels, fetchAiModelCatalogue, saveAiModels } from "../api/integrations";

const AI_MODELS = ["integrations", "ai"];

// The write sits under the Anthropic prefix, not this one: the gear dialog
// locks itself on `useIsMutating({mutationKey: ["integrations", rowId]})`,
// and a save it cannot see is a save the admin can close mid-flight and
// never learn failed.
const AI_MODELS_WRITE = ["integrations", "anthropic", "models"];

export function useAiModels(enabled: boolean) {
  return useQuery({
    queryKey: [...AI_MODELS, "choices"],
    queryFn: fetchAiModels,
    staleTime: 60_000,
    enabled,
  });
}

// The catalogue is a live call to Anthropic and changes on their release
// schedule, not ours - held far longer, and never retried into a spinner.
export function useAiModelCatalogue(enabled: boolean) {
  return useQuery({
    queryKey: [...AI_MODELS, "catalogue"],
    queryFn: fetchAiModelCatalogue,
    staleTime: 10 * 60_000,
    retry: false,
    enabled,
  });
}

export function useSaveAiModels() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: AI_MODELS_WRITE,
    mutationFn: saveAiModels,
    onSuccess: async () => {
      // The choice only. Saving one does not change what the key serves,
      // and the awaited refetch would hold the form for as long as
      // Anthropic takes to answer.
      await queryClient.invalidateQueries({ queryKey: [...AI_MODELS, "choices"] });
    },
  });
}
